import { Box, createTheme, IconButton, InputAdornment, Select, SelectChangeEvent, ThemeProvider, Tooltip, Typography } from "@mui/material";
import MenuMui from '@mui/material/Menu';
import MenuItemMui from '@mui/material/MenuItem';
import { MouseEvent, useMemo } from "react";
import { MenuItem } from "react-pro-sidebar";
import { useNavigate, useParams } from "react-router-dom";
import { ISelectList } from "./ContentSideComp";
import "../../Sidebar/Prosidebar.css"
import { Backspace } from "@mui/icons-material";

export interface ContentbarProps<T>{
    children: string;
    title?: string;
    conditional?: boolean;
    fill?: string;
    footer?: boolean;
    icon?: JSX.Element;
    onClick?: (e: MouseEvent<HTMLElement, globalThis.MouseEvent>) => void
    handleChange?: (event: React.MouseEvent) => void,
    isSelect:boolean;
    disabled: boolean;
    renderOption: boolean;

    selectionList?: T[];
    isSelectField?: boolean,
    anchorElSelect?: HTMLElement | null,
    handleClickSelect?: (event: React.MouseEvent<HTMLButtonElement>) => void,
    handleCloseSelect?: () => void,
    nameOrg?: string,
    onChangeSelection?: (selectEvent: SelectChangeEvent | undefined, mouseEvent?: MouseEvent<HTMLLIElement, globalThis.MouseEvent>) => void,
    openSelect?: boolean,
    selectList?: T[];
    selectValue?: string;
    isCollapsed?: boolean;
    isWorkspace?: boolean;
}



const theme = createTheme({
    components: {
        MuiTooltip: {
        styleOverrides: {
            tooltip: {
            backgroundColor: '#E9EFF4',
            color: '#22638D',
            height: "21px",
            textAlign: "left",
            font:" normal normal normal 14px Segoe UI",
            opacity: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)"
            },
            arrow: {
            color: '#E9EFF4',
            },
        },
        },
    },
});

export const ContentSideCompSelectField: React.FC<ContentbarProps<ISelectList>> = ({
    isCollapsed,
    disabled,
    children,
    icon,
    anchorElSelect,
    handleClickSelect,
    handleCloseSelect,
    nameOrg,
    onChangeSelection,
    openSelect,
    selectList,
    selectValue,
    isWorkspace,
}) => {

    const navigate = useNavigate();
    const { idWorkspace } = useParams();
    
    const processedSelectList = useMemo(() => {
        if (!selectList) return [];
        
        const hasDefaultOption = selectList.some(item => item.id === "1");
        
        if (hasDefaultOption) {
            return selectList;
        }
        
        return [
            ...selectList
        ];
    }, [selectList]);


    return (
        <>
            { !isCollapsed && (
                <MenuItem
                        className={`${disabled ? "disabled select" : 'select'}`}
                    >
                    <Typography
                        color="#000"
                        fontSize="12px"
                        fontFamily="Segoe UI"
                        fontWeight="600"
                    >
                        { children }
                    </Typography>
                </MenuItem>
            ) }
            <MenuItem
                icon={isCollapsed && (
                <ThemeProvider theme={theme}>
                    <Tooltip title={children} placement='bottom-end' arrow>
                        <IconButton disabled={disabled} onClick={(e) => handleClickSelect!(e)} sx={{ width: "36px", height: "36px", borderRadius: "4px", border: `1px solid ${openSelect ? "#22638D" : "#F2F2F2"}` }}>
                            <Box sx={{
                                border: "1px solid #F2F2F2",
                                borderRadius: "4px",
                                width: "24px",
                                height: "24px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                { icon }
                            </Box>
                        </IconButton>
                    </Tooltip>
                </ThemeProvider>
                )}
                style={{ marginBottom: `${isCollapsed ? "10px" : "0px"}` }}
                className={"select"}
            >
                { !isCollapsed && (
                <Select
                    fullWidth
                    sx={{
                        height: "36px",
                        "& .MuiInputBase-root": {
                            paddingLeft: "30px",
                        },
                    }}
                    MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxHeight: "180px",
                                    maxWidth: "190px",
                                    width: "190px"
                                }
                            },
                        sx: {
                            "& .MuiPaper-root": {
                                border: "1px solid #22638D",
                                borderRadius: "4px",
                                boxShadow: "2px 2px 6px #0000001A",
                                left: `${!isCollapsed ? "15px !important" : ""}`
                            }
                        }
                    }}
                    onChange={(e) => onChangeSelection!(e, undefined)}
                    value={selectValue}
                    inputProps={{
                        style: {
                            paddingLeft: "30px",
                        },
                    }}
                    startAdornment={
                        <InputAdornment position='start'>
                            <Box
                                width="24px"
                                height="24px"
                                borderRadius="1px"
                                border="1px solid #F2F2F2"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                position="absolute"
                                left={6}
                            >
                                { icon }
                            </Box>
                        </InputAdornment>
                    }
                    className={"select"}
                    disabled={disabled}
                >
                    {processedSelectList.length > 0 && processedSelectList.map(({ name, id, internalName }) => (
                    <MenuItemMui
                        value={internalName != undefined ? internalName : id}
                        key={id}
                        sx={{
                            padding: "16px",
                        }}
                        style={{
                            paddingLeft: 0
                        }}
                        onClick={() => internalName == undefined ? navigate(`/${nameOrg}/wsallowed/${id}`) : navigate(`/${internalName}`)}
                    >
                        <Typography
                            fontSize="14px"
                            maxWidth="150px"
                            textOverflow="ellipsis"
                            overflow="hidden"
                            marginLeft="12px"
                            fontFamily="Segoe UI"
                            fontWeight="600"
                        >
                            {name}
                        </Typography>
                    </MenuItemMui>
                    ))}
                </Select>
                ) }
                <MenuMui
                    id="basic-menu"
                    anchorEl={anchorElSelect}
                    open={openSelect!}
                    onClose={handleCloseSelect}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                    style={{
                        left: "15px"
                    }}
                    sx={{
                            width: "190px",
                            height: "180px",
                            "& .MuiPaper-root": {
                                border: "1px solid #22638D",
                                borderRadius: "4px",
                                boxShadow: "2px 2px 6px #0000001A",
                                left: `${!isCollapsed ? "15px !important" : ""}`
                        }
                    }}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                { processedSelectList.length > 0 && processedSelectList.map(({ name, id, internalName }) => (
                    <MenuItemMui
                    value={internalName != undefined ? internalName : id}
                    key={id}
                    sx={{
                        padding: "16px"
                    }}
                    style={{
                        paddingLeft: "0px",
                    }}
                    onClick={(e) => {
                        internalName == undefined ? navigate(`/${nameOrg}/wsallowed/${id}`) : navigate(`/${internalName}`)
                        onChangeSelection!(undefined, e);
                    }}
                    id={internalName != undefined ? internalName : id}
                    >
                        <Typography
                            fontSize="14px"
                            maxWidth="150px"
                            textOverflow="ellipsis"
                            overflow="hidden"
                            marginLeft="12px"
                            fontFamily="Segoe UI"
                            fontWeight="600"
                        >
                            {name}
                        </Typography>
                    </MenuItemMui>
                )) }
                </MenuMui>
            </MenuItem>
        </>
    )
}